import { IPartialReducer } from "../../../../../core/core-redux/reduxTypes";
import { DrawLayersState } from "../drawLayersReducer";

export const drawLayersPartialReducer: IPartialReducer<DrawLayersState> = (state, action) => {
    return {
        enabled: action.enabled,
    };
};
